<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} LIMPIARREJAS</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="LIMPIARREJAS" width="100%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
        </div>
        <div class="grid">
          <div class="column">
            <HmiButton label="MARCHA AUTOM. LIMPIARREJAS" width="100%" height="20%" :size="1.7" :color="marchaAutomatica == '1'
              ? 'yellow'
              : 'silver'"
              @click.native="escrituraAlternaHR(direccionVariablesBit.MARCHA_AUTOMATICA_ESCRITURA, marchaAutomatica)">
            </HmiButton>
            <HmiButton label="CICLO MANUAL LIMP." width="100%" height="20%" :size="1.7" :color="cicloManualLimpieza == '1'
              ? 'yellow'
              : 'silver'"
              @touchstart.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_LIMPIEZA_ESCRITURA, '1')"
              @touchend.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_LIMPIEZA_ESCRITURA, '0')"
              @mousedown.native="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_LIMPIEZA_ESCRITURA, '1')"
              @mouseup.native="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_LIMPIEZA_ESCRITURA, '0')">
            </HmiButton>
            <HmiButton label="MARCHA AUTOM. BOMBA" width="100%" height="20%" :size="1.7" :color="marchaAutomaticaBomba == '1'
              ? 'yellow'
              : 'silver'"
              @click.native="escrituraAlternaHR(direccionVariablesBit.MARCHA_AUTOMATICA_BOMBA_ESCRITURA, marchaAutomaticaBomba)">
            </HmiButton>
            <HmiButton label="CICLO MANUAL BOMBA" width="100%" height="20%" :size="1.7" :color="cicloManualBomba == '1'
              ? 'yellow'
              : 'silver'"
              @touchstart.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_BOMBA_ESCRITURA, '1')"
              @touchend.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_BOMBA_ESCRITURA, '0')"
              @mousedown.native="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_BOMBA_ESCRITURA, '1')"
              @mouseup.native="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_BOMBA_ESCRITURA, '0')">
            </HmiButton>
          </div>
          <div class="column">
            <HmiLabel label="TIEMPO ESPERA Min." width="100%" height="20%" :size="1.7" color="cyan"></HmiLabel>
            <HmiLabel label="TIEMPO BOMBA Seg." width="100%" height="20%" :size="1.7" color="cyan"></HmiLabel>
            <HmiLabel label="Nº MANIOBRAS" width="100%" height="20%" :size="1.7" color="cyan"></HmiLabel>
            <HmiButton label="BOMBA MANUAL" width="100%" height="20%" :size="1.7" :color="bombaManual == '1'
              ? 'yellow'
              : 'silver'"
              @click.native="escrituraAlternaHR(direccionVariablesBit.BOMBA_MANUAL_ESCRITURA, bombaManual)">
            </HmiButton>
          </div>
          <div class="column">
            <HmiLabel :label="formato3digitos(tiempoEspera)" width="100%" height="20%" :size="1.7" color="#56FF56"
              :editable="true" @input="escrituraDM($event, direccionVariables.TIEMPO_ESPERA_ESCRITURA, 1)"></HmiLabel>
            <HmiLabel :label="formato3digitos(tiempoBomba)" width="100%" height="20%" :size="1.7" color="#56FF56"
              :editable="true" @input="escrituraDM($event, direccionVariables.TIEMPO_BOMBA_ESCRITURA, 1)"></HmiLabel>
            <HmiLabel :label="formato6digitos(numeroManiobras)" width="100%" height="20%" :size="1.7" color="silver">
            </HmiLabel>
            <div style="height: 20%; display: flex; justify-content: center">
              <HmiLabel label="000000" width="70%" height="50%" :size="1.7" color="#56FF56" :editable="true"
                @input="escritura($event, '0124', 2)"></HmiLabel>
            </div>
          </div>
        </div>
        <div class="button">
          <div class="empty"></div>
          <div class="empty"></div>
          <HmiButton label="SALIR" width="33%" height="100%" :size="1.7" color="silver" @click.native="navigateToMenu">
          </HmiButton>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiButton from "../HMI/HmiButton.vue";
import HmiLabel from "../HMI/HmiLabel.vue";
import HmiPantalla from "../HMI/HmiPantalla.vue";
export default {
  name: "LimpiarrejasPantalla",
  components: {
    HmiButton,
    HmiLabel,
    HmiPantalla,
  },
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      return {
        TIEMPO_ESPERA_LECTURA: 10, // Correspondiente a Dm32
        TIEMPO_ESPERA_ESCRITURA: "Dm0032", // Correspondiente a Dm32
        TIEMPO_BOMBA_LECTURA: 11, // Correspondiente a Dm33
        TIEMPO_BOMBA_ESCRITURA: "Dm0033", // Correspondiente a Dm33
        NUMERO_MANIOBRAS_1_LECTURA: 119, // Correspondiente a Dm124
        NUMERO_MANIOBRAS_2_LECTURA: 120, // Correspondiente a Dm124
      };
    },

    direccionVariablesBit() {
      return {
        MARCHA_AUTOMATICA_LECTURA: [142, 1], // Correspondiente a h.28.10
        MARCHA_AUTOMATICA_ESCRITURA: ["Hr0028", 10], // Correspondiente a h28.10
        MARCHA_AUTOMATICA_BOMBA_LECTURA: [142, 3], // Correspondiente a h.28.13
        MARCHA_AUTOMATICA_BOMBA_ESCRITURA: ["Hr0028", 13], // Correspondiente a h28.13
        BOMBA_MANUAL_LECTURA: [142, 5], // Correspondiente a h.28.15
        BOMBA_MANUAL_ESCRITURA: ["Hr0028", 15], // Correspondiente a h28.15
        CICLO_MANUAL_LIMPIEZA_LECTURA: [142, 2], // Correspondiente a 28.11
        CICLO_MANUAL_LIMPIEZA_ESCRITURA: ["Ir0028", 11], // Correspondiente a 28.11
        CICLO_MANUAL_BOMBA_LECTURA: [142, 4], // Correspondiente a 28.14
        CICLO_MANUAL_BOMBA_ESCRITURA: ["Ir0028", 14], // Correspondiente a 28.14
      };
    },

    tiempoEspera() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_ESPERA_LECTURA
        ];
      }
      return "0000";
    },

    tiempoBomba() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_BOMBA_LECTURA
        ];
      }
      return "0000";
    },

    numeroManiobras() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.NUMERO_MANIOBRAS_2_LECTURA
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.NUMERO_MANIOBRAS_1_LECTURA
          ]
        );
      }
      return "00000000";
    },

    marchaAutomatica() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MARCHA_AUTOMATICA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MARCHA_AUTOMATICA_LECTURA[1]
        );
      }
      return "0";
    },

    marchaAutomaticaBomba() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MARCHA_AUTOMATICA_BOMBA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MARCHA_AUTOMATICA_BOMBA_LECTURA[1]
        );
      }
      return "0";
    },

    bombaManual() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.BOMBA_MANUAL_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.BOMBA_MANUAL_LECTURA[1]
        );
      }
      return "0";
    },

    cicloManualLimpieza() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CICLO_MANUAL_LIMPIEZA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CICLO_MANUAL_LIMPIEZA_LECTURA[1]
        );
      }
      return "0";
    },

    cicloManualBomba() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CICLO_MANUAL_BOMBA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CICLO_MANUAL_BOMBA_LECTURA[1]
        );
      }
      return "0";
    },
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "6", "");
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "6", "");
    },

    formato3digitos(dato) {
      return dato.substring(1, 4);
    },

    formato6digitos(dato) {
      return dato.substring(2, 8);
    },

    escrituraDM(value, direccion, canales) {
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },

    escrituraAlternaHR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      const nuevoValor = valor == "0" ? "1" : "0";

      // Construir el payload 
      const payload = {
        name: "escrituraHR",
        direccion: direccion,
        valor: nuevoValor,
        bit: bit,
      };

      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },

    escrituraMomentaneaHR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      // Construir el payload
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: valor,
        bit: bit,
      };
      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },

    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },

    escritura(value, direccion, canales) {
      console.log(value);
      console.log(direccion);
      const payload = {
        name: "escritura",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  height: 75%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: clamp(1px, 2vw, 20px);
  gap: clamp(1px, 2vw - 5px, 20px);
}

.column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 33%;
  height: 100%;
}

.empty {
  width: 33%;
}

.button {
  height: 10%;
  display: flex;
  justify-content: space-between;
  gap: clamp(1px, 2vw - 5px, 20px);
}
</style>
